import React, { useState,useEffect } from 'react';
import { Grid,Container, Typography, Box, TextField, makeStyles } from '@material-ui/core';
import "./mortgagecalculator.css"




const useStyles = makeStyles(() => ({
  bannerContainer: {
    marginTop: '100px',
    marginBottom: '100px',
  },

  titleCal:{
    
  },

  label :{
    width: '75%',
    height: 'fit-content',
    top: '4px',
    gap: '5px',
    fontFamily: 'DM Sans, sans-serif',
    fontWeight: '400',
    fontSize: '28px',
    lineHeight: '18.23px',
    marginTop: '15px',
    marginBottom: '15px',
  },
  
  
  inputContainercal: {
   // display: 'flex',
    //alignItems: 'center',
    //marginBottom: '16px',
  },
  input: {
    width: '75%',
    height: 'fit-content',
    paddingTop: '14px',
    paddingBottom: '14px',
    paddingLeft: '8px',
    paddingRight: '16px',
    borderRadius: '8px',
    border: '1px solid #000',
    fontSize: '28px',
  },
}));

const MortgageCalculator = ({ onMonthlyPaymentChange }) => {
  const classes = useStyles();
  const [principal, setPrincipal] = useState('400000');
  const [downPaymentPercentage, setDownPaymentPercentage] = useState('20');
  const [interestRate, setInterestRate] = useState('7.03');
  const [loanTerm, setLoanTerm] = useState('30');
  const [propertyTax, setPropertyTax] = useState('');
  const [homeInsurance, setHomeInsurance] = useState('');
  const [pmi, setPMI] = useState('');
  const [hoaFees, setHOAFees] = useState('');
  const [monthlyPayment, setMonthlyPayment] = useState(0);

  const calculateMonthlyPayment = () => {
    const loanAmount = parseFloat(principal* (100-downPaymentPercentage)) / 100;
    const interest = parseFloat(interestRate) / 100 / 12;
    const loanDuration = parseFloat(loanTerm) * 12;

    if (loanAmount && interest && loanDuration) {
      const monthlyRate = Math.pow(1 + interest, loanDuration);
      const monthlyPayment = (loanAmount * interest * monthlyRate) / (monthlyRate - 1);
      setMonthlyPayment(monthlyPayment.toFixed(2));
      onMonthlyPaymentChange(monthlyPayment.toFixed(2)); // Pass the monthly payment to the parent component
    } else {
      setMonthlyPayment(0);
      onMonthlyPaymentChange(0); // Pass 0 as the monthly payment to the parent component
    }
  };

  const handleChange = (event) => {
    const value = event.target.value;
    const name = event.target.name;

    // Update the corresponding state based on the input field name
    switch (name) {
      case 'principal':
        setPrincipal(value);
        break;
      case 'downPaymentPercentage':
        setDownPaymentPercentage(value);
        break;
      case 'interestRate':
        setInterestRate(value);
        break;
      case 'loanTerm':
        setLoanTerm(value);
        break;
      case 'propertyTax':
        setPropertyTax(value);
        break;
      case 'homeInsurance':
        setHomeInsurance(value);
        break;
      case 'pmi':
        setPMI(value);
        break;
      case 'hoaFees':
        setHOAFees(value);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    calculateMonthlyPayment();
  }, [principal, interestRate, loanTerm, downPaymentPercentage]); // Trigger the calculation whenever the relevant inputs change

  const calculateTotalPayment = () => {
    const baseMonthlyPayment = parseFloat(monthlyPayment);
    const tax = parseFloat(propertyTax);
    const insurance = parseFloat(homeInsurance);
    const pmiRate = parseFloat(pmi) / 100;
    const hoa = parseFloat(hoaFees);

    const totalPayment = baseMonthlyPayment + tax / 12 + insurance / 12 + (baseMonthlyPayment * pmiRate) / 12 + hoa;
    return totalPayment.toFixed(2);
  };

  return (
 
     
 
        <Box marginLeft={5}>
      <Box  marginBottom={5}>
      <Typography  variant="h4" style={{ fontSize: '32px', fontFamily: 'Inter', fontWeight: 700 }}>
          Mortgage Calculator Tool
        </Typography>
      </Box>
      <Grid container className="mortgageCalContainer" spacing={2} border={1} >
       
          <Grid item  xs={12} sm={12} md={6}>
           
          
            <label className={classes.label}>Home Price</label>
  
            <div>
            <input
              type="number"
              name="principal"
              value={principal}
              onChange={handleChange}
              className={classes.input}
            />
          </div>

          </Grid>
          <Grid item  xs={12} sm={12} md={6}>

        
            <label className={classes.label}>Down Payment (%):</label>
    
            <div>
            <input
              type="number"
              step="0.01"
              name="downPaymentPercentage"
              value={downPaymentPercentage}
              onChange={handleChange}
              className={classes.input}
              
            />
          </div>
          </Grid>

          <Grid item  xs={12} sm={12} md={6}>
      
            <label className={classes.label}>Loan Term (years):</label>
       
            <div>
            <input
              type="number"
              name="loanTerm"
              value={loanTerm}
              onChange={handleChange}
              className={classes.input}
            />
          </div>
              
          </Grid>




        
          <Grid item  xs={12} sm={12} md={6}>
    
            <label className={classes.label}>Interest Rate (%):</label>
       
            <div>
            <input
              type="number"
              step="0.01"
              name="interestRate"
              value={interestRate}
              onChange={handleChange}
              className={classes.input}
            />
          </div>
          </Grid>

          <Grid item  xs={12} sm={12} md={6}>
    
            <label className={classes.label}>Zip Code</label>
    
            <div>
            <input
              type="number"
             
           
      
              className={classes.input}
            />
          </div>

          </Grid>
        

      </Grid>
      </Box>


  



  );
};


export default MortgageCalculator;
